import { initTranslation } from "../modules/i18n";
import initPage from "../modules/page";
import { initCarousels } from "../modules/product-collection";
import { createProductImpressionObserver } from "../modules/analytics";
import { sendFacebookPixelEvent } from "../modules/analytics/facebook-pixel.js";
import { initAccordion } from "../modules/ui.js";
import {
  getKeyboardFocusableElements,
  disableBodyScroll,
  enableBodyScroll,
} from "../modules/utilities";
import "../../scss/brand.scss";
import { select, selectAll } from "@fruugo/utilities";
import { initSelectSellerMenu } from "../modules/components/side-menu/SelectSellerMenu";

declare let window: SearchPage;

async function initBrandPage() {
  await initTranslation();
  initPage();
  initCarousels();
  initPageSpecificAnalytics();
  initAccordion();
  initSelectSellerMenu();

  // Intersection observer for analytics product impressions
  const observer = createProductImpressionObserver();
  document
    .querySelectorAll(".product-item")
    .forEach((item) => observer.observe(item));

  // Utility Menus
  document.querySelectorAll("#sort-by, #page-size").forEach((select) =>
    select.addEventListener("change", (e: Event) => {
      const target = e.target as HTMLSelectElement;
      window.location.href = target?.value;
    })
  );

  const sidebar = select<HTMLElement>(".sidebar");
  if (sidebar) {
    const backdrop = document.createElement("div");
    const keyboardElements = getKeyboardFocusableElements(sidebar);
    const firstFocusable = keyboardElements[0];

    backdrop.classList.add("sidebar-backdrop");

    const openSidebar = () => {
      disableBodyScroll();
      document.body.classList.add("sidebar-open");
      document.body.appendChild(backdrop);
      // put focus just after close button, so first tab selects first useable item instead
      if (firstFocusable) {
        firstFocusable.focus();
        firstFocusable.blur();
      }
    };

    const closeSidebar = () => {
      enableBodyScroll();
      document.body.classList.remove("sidebar-open");
      backdrop.parentNode?.removeChild(backdrop);
    };

    const mobileFilters = select(".mobile-filters");
    mobileFilters && mobileFilters.addEventListener("click", openSidebar);

    sidebar
      .querySelector(".btn-close")
      ?.addEventListener("click", closeSidebar);
  }
}

function initPageSpecificAnalytics() {
  if (window.pageType === "search") {
    if (!window.searchInformation.searchQuery) return;

    sendFacebookPixelEvent("Search", {
      content_ids: [...Array.from(selectAll<HTMLElement>(".product-item"))].map(
        (p) => p.dataset.productid
      ),
      search_string: window.searchInformation.searchQuery,
    });
  }
}

initBrandPage();
